import { CSSProperties } from 'react';

/** Keep drag source and custom drag layer fully painted (content-visibility breaks react-dnd). */
export const dragInteractionStyle: CSSProperties = {
  contentVisibility: 'visible',
};
